<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div class="flex flex-col gap-5 relative bg-white rounded-[15px] p-[30px] w-full max-w-[528px]">
        <button (click)="close.emit()"
            class="w-7 h-7 flex items-center justify-center text-black cursor-pointer absolute -right-2.5 -top-2.5 rounded-full bg-light-black-100 hover:bg-black hover:text-white duration-200 ease-in-out">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0423 0.708008L0.70975 12.0406M12.0416 12.0413L0.708984 0.708811" stroke="currentColor"
                    stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
        <!-- modal content -->
        <div class="flex flex-col gap-[30px]">
            <h2 class="text-black text-xl lg:text-2xl !leading-5 font-bold text-center">Send tip</h2>

            <div class="flex items-center justify-center flex-col gap-5">
                <img src="assets/images/leaderboard/popular-image-w60.png" alt="profile-image"
                    class="w-[100px] h-[100px] object-cover rounded-full" />
                <h3 class="text-black text-base md:text-lg lg:text-xl font-medium">To wasianiversonworldchamp2025</h3>
            </div>
            <div class="flex flex-col gap-3.5">
                <div class="flex items-center justify-between">
                    <p class="text-black text-sm sm:text-base md:text-lg !leading-3">
                        Amount
                    </p>
                    <p class="text-secondary-text-black text-sm sm:text-base md:text-lg !leading-3">
                        $0.00 available Max
                    </p>
                </div>

                <input
                    type="text"
                    placeholder="$0.00"
                    (input)="onAmountChange($any($event.target).value)"
                    class="placeholder:text-secondary-text-black text-black text-base font-normal !leading-3 rounded-xl py-4 px-5 border"
                    [ngClass]="{
                        'border-secondary-button-black': !isInsufficient,
                        'border-primary-text-yellow': isInsufficient
                    }"
                />

                <!-- Error message -->
                <p *ngIf="isInsufficient" class="text-primary-text-yellow text-sm font-medium">
                    Insufficient funds. Please withdraw less USDC than your balance.
                </p>
            </div>

            <button
                class="w-full flex items-start justify-center gap-2 text-sm font-syne font-semibold text-white bg-black border border-transparent hover:bg-secondary-button-black hover:text-black hover:border-black rounded-lg cursor-pointer duration-200 ease-in-out pt-3 pb-2.5 px-4">
                Send
            </button>
        </div>
    </div>
</div>